import request from '@/router/axios';
export const getDMList = (obj) => {
  return request({
    url:'/json/dws/backup.json',
    method: 'get',
    data:obj
  })
};
